import { ThemeProvider, createTheme } from '@mui/material';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { Alert, Snackbar } from '@mui/material';
import React from 'react';
import AppLayout from './AppLayout';
import Footer from './components/Navigation/Footer';
import Navbar from './components/Navigation/Navbar';
import { useAppContext } from './contexts/AppContext';
import About from './pages/About';
import Configurator from './pages/Configurator';
import FAQ from './pages/FAQ';
import Gallery from './pages/Gallery';
import Home from './pages/Home';
import Products from './pages/Products';
import Reviews from './pages/Reviews';
import Events from './pages/Events';
import EventDetails from './pages/EventDetail';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8B4513', // Saddle Brown - good for leather theme
      light: '#A0522D',
      dark: '#654321',
    },
    secondary: {
      main: '#D2B48C', // Tan
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
    },
  },
});

function App() {

  const { snackbarMessage, snackbarSeverity, isSnackbarOpen, hideSnackbar } = useAppContext();

  const routes = [
    { path: "/", element: <Home />, title: "KBros Leather | Handcrafted Leather Goods" },
    { path: "/products", element: <Products />, title: "KBros Leather | Our Products" },
    { path: "/gallery", element: <Gallery />, title: "KBros Leather | Gallery" },
    { path: "/configurator", element: <Configurator />, title: "KBros Leather | Wallet Designer" },
    { path: "/about", element: <About />, title: "KBros Leather | About Us" },
    { path: "/faq", element: <FAQ />, title: "KBros Leather | FAQ" },
    { path: "/reviews", element: <Reviews />, title: "KBros Leather | Reviews" },
    { path: "/events", element: <Events />, title: "KBros Leather | Events" },
    { path: "/events/:id", element: <EventDetails />, title: "KBros Leather | Event Details" },
  ];

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AppLayout routes={routes}>
          <div className="App">
            <Navbar />
            <main style={{ minHeight: 'calc(100vh - 160px)' }}>
              <Routes>
                {routes.map(route => (
                  <Route key={route.path} path={route.path} element={route.element} />
                ))}
              </Routes>
            </main>
            <Footer />
            <Snackbar open={isSnackbarOpen} autoHideDuration={3000} onClose={hideSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
              <Alert onClose={hideSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                {snackbarMessage}
              </Alert>
            </Snackbar>
          </div>
        </AppLayout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
